export default __webpack_public_path__ + "static/media/VBVT-Charities-Aid-Foundation.723ccdc7.jpg";